import { useEffect } from "react";
import TagManager from "react-gtm-module";
import { useDueDatesAuth } from "../hooks/useDueDatesAuth";

export const useTagManager = () => {
  const { UserId, UserEmail } = useDueDatesAuth();

  useEffect(() => {
    if (import.meta.env.PUBLIC_ENVIRONMENT === "PROD") {
      TagManager.initialize({
        gtmId: import.meta.env.PUBLIC_GTM_ID,
        dataLayer: {
          UserId,
          UserEmail,
          environmentName: "PROD"
        }
      });
    }
  }, [UserId, UserEmail]);
};
